// Données mockées pour la gestion des ressources et inventaire

export type AssetStatus = 'available' | 'assigned' | 'maintenance' | 'retired' | 'lost' | 'in_stock' | 'deployed' | 'in_repair' | 'damaged' | 'maintenance_due';
export type AssetCategory = 'equipment' | 'vehicle' | 'material' | 'tool' | 'plv' | 'refrigerator' | 'umbrella' | 'uniform' | 'stand' | 'other';

export interface Asset {
  id: string;
  name: string;
  category: AssetCategory;
  description?: string;
  serial_number?: string;
  qr_code: string;
  barcode?: string;
  status: AssetStatus;
  location?: string;
  latitude?: number;
  longitude?: number;
  current_project_id?: string;
  current_project_name?: string;
  assigned_to?: string;
  assigned_to_name?: string;
  purchase_date?: string;
  last_maintenance_date?: string;
  next_maintenance_date?: string;
  maintenance_due_date?: string;
  purchase_price?: number;
  current_value?: number;
  brand?: string;
  model?: string;
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface AssetAssignment {
  id: string;
  asset_id: string;
  asset_name: string;
  project_id: string;
  project_name: string;
  assigned_to: string;
  assigned_to_name: string;
  assigned_by: string;
  assigned_by_name: string;
  location: string;
  latitude?: number;
  longitude?: number;
  status: 'active' | 'returned' | 'lost';
  assigned_at: string;
  returned_at?: string;
  notes?: string;
}

export interface MaintenanceAlert {
  id: string;
  asset_id: string;
  asset_name: string;
  type: 'damaged' | 'maintenance_due' | 'overdue';
  severity: 'low' | 'medium' | 'high' | 'urgent';
  message: string;
  due_date?: string;
  created_at: string;
  resolved_at?: string;
  resolved_by?: string;
}

export const mockAssets: Asset[] = [
  {
    id: 'asset-001',
    name: 'Parasol SOBEBRA Premium',
    category: 'umbrella',
    description: 'Parasol promotionnel avec logo SOBEBRA, dimensions 2x2m',
    serial_number: 'UMB-2024-001',
    qr_code: 'QR-UMB-001',
    barcode: '1234567890123',
    status: 'deployed',
    location: 'Marché Dantokpa, Cotonou',
    latitude: 6.3654,
    longitude: 2.4183,
    current_project_id: '1',
    current_project_name: 'Campagne Activation Point de Vente - Cotonou Centre',
    assigned_to: 'agent-001',
    assigned_to_name: 'Koffi Amoussou',
    purchase_date: '2024-01-15',
    last_maintenance_date: '2024-10-01',
    next_maintenance_date: '2025-01-01',
    purchase_price: 45000,
    current_value: 40000,
    brand: 'SOBEBRA',
    model: 'Premium 2024',
    created_at: '2024-01-15T10:00:00Z',
    updated_at: '2024-11-15T14:00:00Z',
  },
  {
    id: 'asset-002',
    name: 'Réfrigérateur SOBEBRA 200L',
    category: 'refrigerator',
    description: 'Réfrigérateur de marque avec logo SOBEBRA, capacité 200L',
    serial_number: 'FRIDGE-2024-001',
    qr_code: 'QR-FRIDGE-001',
    barcode: '1234567890124',
    status: 'in_stock',
    location: 'Entrepôt Agence Zenith, Cotonou',
    latitude: 6.3667,
    longitude: 2.4167,
    purchase_date: '2024-02-10',
    last_maintenance_date: '2024-11-01',
    next_maintenance_date: '2025-02-01',
    purchase_price: 350000,
    current_value: 320000,
    brand: 'SOBEBRA',
    model: 'CoolMax 200L',
    created_at: '2024-02-10T10:00:00Z',
    updated_at: '2024-11-10T10:00:00Z',
  },
  {
    id: 'asset-003',
    name: 'Stand PLV Modulaire 3x2m',
    category: 'stand',
    description: 'Stand promotionnel modulaire avec bannière SOBEBRA',
    serial_number: 'STAND-2024-001',
    qr_code: 'QR-STAND-001',
    barcode: '1234567890125',
    status: 'deployed',
    location: 'Zone Akpakpa, Cotonou',
    latitude: 6.3700,
    longitude: 2.4200,
    current_project_id: '3',
    current_project_name: 'Déploiement Matériel Promotionnel - Zone Akpakpa',
    assigned_to: 'agent-003',
    assigned_to_name: 'Jean Sègbè',
    purchase_date: '2024-03-05',
    last_maintenance_date: '2024-09-15',
    next_maintenance_date: '2024-12-15',
    purchase_price: 125000,
    current_value: 110000,
    brand: 'SOBEBRA',
    model: 'Modular Pro',
    created_at: '2024-03-05T10:00:00Z',
    updated_at: '2024-11-10T09:00:00Z',
  },
  {
    id: 'asset-004',
    name: 'Uniforme Agent Terrain SOBEBRA',
    category: 'uniform',
    description: 'Uniforme complet (pantalon + chemise) avec logo SOBEBRA',
    serial_number: 'UNIF-2024-001',
    qr_code: 'QR-UNIF-001',
    status: 'in_stock',
    location: 'Entrepôt Agence Zenith, Cotonou',
    purchase_date: '2024-04-01',
    purchase_price: 15000,
    current_value: 12000,
    brand: 'SOBEBRA',
    model: 'Standard',
    created_at: '2024-04-01T10:00:00Z',
    updated_at: '2024-11-01T10:00:00Z',
  },
  {
    id: 'asset-005',
    name: 'Bannière Roll-up SOBEBRA',
    category: 'plv',
    description: 'Bannière roll-up avec support, dimensions 85x200cm',
    serial_number: 'PLV-2024-001',
    qr_code: 'QR-PLV-001',
    barcode: '1234567890126',
    status: 'in_repair',
    location: 'Atelier Réparation, Cotonou',
    purchase_date: '2024-05-10',
    last_maintenance_date: '2024-10-20',
    next_maintenance_date: '2025-01-20',
    purchase_price: 35000,
    current_value: 30000,
    brand: 'SOBEBRA',
    model: 'Roll-up Pro',
    created_at: '2024-05-10T10:00:00Z',
    updated_at: '2024-11-12T10:00:00Z',
  },
  {
    id: 'asset-006',
    name: 'Réfrigérateur SOBEBRA 150L',
    category: 'refrigerator',
    description: 'Réfrigérateur compact avec logo SOBEBRA, capacité 150L',
    serial_number: 'FRIDGE-2024-002',
    qr_code: 'QR-FRIDGE-002',
    barcode: '1234567890127',
    status: 'maintenance_due',
    location: 'Marché Ganhi, Cotonou',
    latitude: 6.3680,
    longitude: 2.4190,
    current_project_id: '1',
    current_project_name: 'Campagne Activation Point de Vente - Cotonou Centre',
    assigned_to: 'agent-001',
    assigned_to_name: 'Koffi Amoussou',
    purchase_date: '2024-02-15',
    last_maintenance_date: '2024-08-15',
    next_maintenance_date: '2024-11-20',
    purchase_price: 280000,
    current_value: 250000,
    brand: 'SOBEBRA',
    model: 'CoolMax 150L',
    created_at: '2024-02-15T10:00:00Z',
    updated_at: '2024-11-15T10:00:00Z',
  },
  {
    id: 'asset-007',
    name: 'Parasol SOBEBRA Standard',
    category: 'umbrella',
    description: 'Parasol promotionnel standard avec logo SOBEBRA',
    serial_number: 'UMB-2024-002',
    qr_code: 'QR-UMB-002',
    status: 'damaged',
    location: 'Entrepôt Agence Zenith, Cotonou',
    purchase_date: '2024-01-20',
    last_maintenance_date: '2024-09-01',
    next_maintenance_date: '2024-12-01',
    purchase_price: 35000,
    current_value: 15000,
    brand: 'SOBEBRA',
    model: 'Standard 2024',
    created_at: '2024-01-20T10:00:00Z',
    updated_at: '2024-11-10T10:00:00Z',
  },
  {
    id: 'asset-008',
    name: 'Kakemono SOBEBRA',
    category: 'plv',
    description: 'Kakemono avec support, dimensions 80x200cm',
    serial_number: 'PLV-2024-002',
    qr_code: 'QR-PLV-002',
    status: 'deployed',
    location: 'Carrefour Ganhi, Cotonou',
    latitude: 6.3680,
    longitude: 2.4190,
    current_project_id: '1',
    current_project_name: 'Campagne Activation Point de Vente - Cotonou Centre',
    assigned_to: 'agent-001',
    assigned_to_name: 'Koffi Amoussou',
    purchase_date: '2024-06-01',
    last_maintenance_date: '2024-10-15',
    next_maintenance_date: '2025-01-15',
    purchase_price: 25000,
    current_value: 22000,
    brand: 'SOBEBRA',
    model: 'Kakemono Pro',
    created_at: '2024-06-01T10:00:00Z',
    updated_at: '2024-11-14T10:00:00Z',
  },
];

export const mockAssignments: AssetAssignment[] = [
  {
    id: 'assign-001',
    asset_id: 'asset-001',
    asset_name: 'Parasol SOBEBRA Premium',
    project_id: '1',
    project_name: 'Campagne Activation Point de Vente - Cotonou Centre',
    assigned_to: 'agent-001',
    assigned_to_name: 'Koffi Amoussou',
    assigned_by: 'agence-001',
    assigned_by_name: 'Agence Zenith Productions',
    location: 'Marché Dantokpa, Cotonou',
    latitude: 6.3654,
    longitude: 2.4183,
    status: 'active',
    assigned_at: '2024-11-01T10:00:00Z',
    notes: 'Affectation pour campagne activation',
  },
  {
    id: 'assign-002',
    asset_id: 'asset-003',
    asset_name: 'Stand PLV Modulaire 3x2m',
    project_id: '3',
    project_name: 'Déploiement Matériel Promotionnel - Zone Akpakpa',
    assigned_to: 'agent-003',
    assigned_to_name: 'Jean Sègbè',
    assigned_by: 'agence-001',
    assigned_by_name: 'Agence Zenith Productions',
    location: 'Zone Akpakpa, Cotonou',
    latitude: 6.3700,
    longitude: 2.4200,
    status: 'active',
    assigned_at: '2024-11-10T07:00:00Z',
    notes: 'Installation urgente',
  },
  {
    id: 'assign-003',
    asset_id: 'asset-006',
    asset_name: 'Réfrigérateur SOBEBRA 150L',
    project_id: '1',
    project_name: 'Campagne Activation Point de Vente - Cotonou Centre',
    assigned_to: 'agent-001',
    assigned_to_name: 'Koffi Amoussou',
    assigned_by: 'agence-001',
    assigned_by_name: 'Agence Zenith Productions',
    location: 'Marché Ganhi, Cotonou',
    latitude: 6.3680,
    longitude: 2.4190,
    status: 'active',
    assigned_at: '2024-11-05T09:00:00Z',
    notes: 'Maintenance prévue le 20 novembre',
  },
  {
    id: 'assign-004',
    asset_id: 'asset-008',
    asset_name: 'Kakemono SOBEBRA',
    project_id: '1',
    project_name: 'Campagne Activation Point de Vente - Cotonou Centre',
    assigned_to: 'agent-001',
    assigned_to_name: 'Koffi Amoussou',
    assigned_by: 'agence-001',
    assigned_by_name: 'Agence Zenith Productions',
    location: 'Carrefour Ganhi, Cotonou',
    latitude: 6.3680,
    longitude: 2.4190,
    status: 'active',
    assigned_at: '2024-11-14T10:00:00Z',
  },
];

export const mockMaintenanceAlerts: MaintenanceAlert[] = [
  {
    id: 'alert-001',
    asset_id: 'asset-006',
    asset_name: 'Réfrigérateur SOBEBRA 150L',
    type: 'maintenance_due',
    severity: 'medium',
    message: 'Maintenance périodique due le 20 novembre 2024',
    due_date: '2024-11-20',
    created_at: '2024-11-15T10:00:00Z',
  },
  {
    id: 'alert-002',
    asset_id: 'asset-007',
    asset_name: 'Parasol SOBEBRA Standard',
    type: 'damaged',
    severity: 'high',
    message: 'Parasol endommagé - nécessite réparation',
    created_at: '2024-11-10T10:00:00Z',
  },
  {
    id: 'alert-003',
    asset_id: 'asset-005',
    asset_name: 'Bannière Roll-up SOBEBRA',
    type: 'damaged',
    severity: 'medium',
    message: 'Support cassé - en réparation',
    created_at: '2024-11-12T10:00:00Z',
  },
];

export const getStatusLabel = (status: AssetStatus): string => {
  switch (status) {
    case 'in_stock':
      return 'En Stock';
    case 'deployed':
      return 'Déployé';
    case 'in_repair':
      return 'En Réparation';
    case 'damaged':
      return 'Endommagé';
    case 'maintenance_due':
      return 'Maintenance Due';
    default:
      return status;
  }
};

export const getStatusColor = (status: AssetStatus): 'success' | 'primary' | 'warning' | 'error' | 'default' => {
  switch (status) {
    case 'in_stock':
      return 'success';
    case 'deployed':
      return 'primary';
    case 'in_repair':
      return 'warning';
    case 'damaged':
      return 'error';
    case 'maintenance_due':
      return 'warning';
    default:
      return 'default';
  }
};

export const getCategoryLabel = (category: AssetCategory): string => {
  switch (category) {
    case 'plv':
      return 'PLV';
    case 'refrigerator':
      return 'Réfrigérateur';
    case 'umbrella':
      return 'Parasol';
    case 'uniform':
      return 'Uniforme';
    case 'stand':
      return 'Stand';
    case 'other':
      return 'Autre';
    default:
      return category;
  }
};




